import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { AlertCircle } from "lucide-react";

export function StockTable({ data }: { data: any[] }) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Produto</TableHead>
            <TableHead>Categoria</TableHead>
            <TableHead>Quantidade</TableHead>
            <TableHead>Quantidade Mínima</TableHead>
            <TableHead>Última Atualização</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.id}>
              <TableCell>
                {item.type.name} {item.material.name} {item.thickness.value}
                {item.thickness.unit} {item.dimension.value}
              </TableCell>
              <TableCell>{item.category.name}</TableCell>
              <TableCell>{item.quantity}</TableCell>
              <TableCell>{item.minimum_quantity}</TableCell>
              <TableCell>
                {new Date(item.updated_at).toLocaleDateString("pt-BR")}
              </TableCell>
              <TableCell>
                {item.quantity <= item.minimum_quantity ? (
                  <div className="flex items-center text-[#E60026]">
                    <AlertCircle className="w-4 h-4 mr-1" />
                    Crítico
                  </div>
                ) : (
                  <div className="text-green-500">Normal</div>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}